export enum ResourceTableOption {
  Matches = "matches",
  NamedResource = "namedResource",
  Shortlists = "shortlists"
}

export const OPTION_ORDER: ResourceTableOption[] = [
  ResourceTableOption.Shortlists,
  ResourceTableOption.Matches,
  ResourceTableOption.NamedResource
];
